import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';

const blueillusionSizes = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  '2L',
  '3L',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  'One Size',
];

export const blueillusionShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: blueillusionSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '9b5d41eef6ad4c118ec4a0106e92b014',
    },
  },
};
